<div [formGroup]="form">
  @if (field?.form) {
  <div class="field-container">
    <!-- DATE FIELD -->
    @if (dateKey) {
    <mat-form-field style="width: 70%" class="p-r-30">
      <mat-label>
        <span>
          {{ cid + '.' + (field.form.name ? field.form.name : dateKey) | translate }}
        </span>
        @if (checkRequiredFields(dateKey)) {
        <span class="mat-error required-asterisk inline"> *</span>
        }
      </mat-label>

      <input
        matInput
        color="primary"
        [matDatepicker]="datePicker"
        [max]="maxDate"
        [min]="minDate"
        [formControlName]="dateKey"
        autocomplete="off"
        (click)="datePicker.open()"
      />

      <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
      <mat-datepicker #datePicker></mat-datepicker>
    </mat-form-field>
    }

    <!-- TIME FIELD (PrimeNG) -->
    @if (timeKey) {
    <mat-form-field style="width: 30%">
      <mat-label fxLayout fxFlex="row">
        <div fxFlex="95">
          <span>
            {{ cid + '.' + (field.form.name ? field.form.name : timeKey) | translate }}
          </span>
          @if (checkRequiredFields(timeKey)) {
          <span class="mat-error required-asterisk inline"> *</span>
          }
        </div>
      </mat-label>

      <p-calendar
        formControlName="{{ timeKey }}"
        [timeOnly]="true"
        [hourFormat]="'24'"
        appendTo="body"
        styleClass="prime-time-picker"
      ></p-calendar>
    </mat-form-field>
    }

    <!-- VALIDATION ERRORS -->
    @if (form?.get(dateKey)?.errors || form?.get(timeKey)?.errors) {

    <!-- DATE ERRORS -->
    @if ( (form.get(dateKey)?.touched || isSubmitted) && form.get(dateKey)?.invalid && form.get(dateKey)?.errors ) {
    <div class="validation-errors date-errors">
      @for (error of (form.get(dateKey)?.errors | pairs); track error.key) {
      <div class="mat-error">
        @if (error.key === 'serverError') { @for (err of error.value; track err) {
        {{ err }}
        } } @else { @if (!field?.hints?.password_helper) { @switch (error.key) { @case ('minlength') {
        {{ 'validation_errors.' + error.key | translate: { xx: error?.value?.requiredLength } }}
        } @case ('maxlength') {
        {{ 'validation_errors.' + error.key | translate: { xx: error?.value?.requiredLength } }}
        } @default {
        {{ 'validation_errors.' + error.key | translate }}
        } } } }
      </div>
      }
    </div>
    }

    <!-- TIME ERRORS -->
    @if ( (form.get(timeKey)?.touched || isSubmitted) && form.get(timeKey)?.invalid && form.get(timeKey)?.errors ) {
    <div class="validation-errors time-errors">
      @for (error of (form.get(timeKey)?.errors | pairs); track error.key) {
      <div class="mat-error">
        @if (error.key === 'serverError') { @for (err of error.value; track err) {
        {{ err }}
        } } @else { @if (!field?.hints?.password_helper) { @switch (error.key) { @case ('minlength') {
        {{ 'validation_errors.' + error.key | translate: { xx: error?.value?.requiredLength } }}
        } @case ('maxlength') {
        {{ 'validation_errors.' + error.key | translate: { xx: error?.value?.requiredLength } }}
        } @default {
        {{ 'validation_errors.' + error.key | translate }}
        } } } }
      </div>
      }
    </div>
    } }
  </div>
  }
</div>
